import { Box, HStack, Heading } from "@chakra-ui/react";

export default function SectionCard({ title, action, children, ...rest }) {
  return (
    <Box variant="baseStyle" bg="app-card" border="1px solid" borderColor="app-border" borderRadius="xl" boxShadow="sm" p={5} {...rest}>
      {title ? (
        <HStack justify="space-between" mb={4}>
          <Heading size="sm">{title}</Heading>
          {action}
        </HStack>
      ) : null}
      {children}
    </Box>
  );
}
